import { SxProps, Box, Typography, Theme } from '@mui/material'
import { ReactNode } from 'react'

export interface PageTitleProps {
  title: string | ReactNode
  id?: string
  sx?: SxProps<Theme>
}

/**
 * Display a common title for a page.
 */
export const PageTitle = (props: PageTitleProps): JSX.Element => {
  return (
    <Box sx={props.sx}>
      <Typography id={props.id} sx={{ lineHeight: '1.4rem' }} variant="h2">{props.title}</Typography>
    </Box>
  )
}
